import { jsx as r } from "react/jsx-runtime";
import { at as a } from "../../../vendor-EQDp64ng.js";
import '../../../assets/index34.css';const o = "_header_115xv_1", t = {
  header: o
};
function c({ children: e }) {
  return /* @__PURE__ */ r(a, { className: t.header, children: e });
}
export {
  c as Header
};
